export default __webpack_public_path__ + "static/media/CheckmarkWhite.f2981361.svg";